import actions from './actions'

const defaultObject = {
    avatar: '',
    desc: '',
    hashtag: [],
    name: '',
    status: '',
    user_id: [],
    object_id: 0,
    education: '',
}

const initState = {
    objects: [],
    currentObject: {},
    textSearch: "",
    begin_time: 0, end_time: 0, type_search: '',
    lastTextSearch: "",

    total: 0,
    pageSize: 12,
    pageIndex: 1,

    // cache
    _status: 1,
    avatar_file: null,

    // modal
    modalInfoObjectState: false,
    modalConfirmDeleteObjectState: false,
    currentListObject: [],
    visibleModalExportObject: false,
    visibleModalPreviewExport: false,
    lstLinkBase64: [],
    suggestionData: [],

}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.UPDATE_TEXT_SEARCH_PARAM_SEARCH:
            return {
                ...state,
                begin_time: action.begin_time ? action.begin_time : state.begin_time,
                end_time: action.end_time ? action.end_time : state.end_time,
                type_search: action.type_search ? action.type_search : state.type_search,

            }
        case actions.type.GET_SUGGESTION_DATA_DONE:
            return {
                ...state,
                ...{
                    suggestionData: action.payload.data
                }
            }
        case actions.type.PARSE_IMAGE_LINK_TO_BASE64_DONE:
            return {
                ...state,
                ...{
                    lstLinkBase64: action.payload.data
                }
            }
        case actions.type.VISIBLE_MODAL_PREVIEW_EXPORT:
            return {
                ...state,
                ...{
                    visibleModalPreviewExport: action.payload.visible
                }
            }
        case actions.type.VISIBLE_MODAL_EXPORT_OBJECT:
            return {
                ...state,
                ...{
                    visibleModalExportObject: action.payload.visible
                }
            }

        case actions.type.LOAD_LIST_OBJECTS:
            return state

        case actions.type.LOAD_LIST_OBJECTS_SUCCESS:
            return {
                ...state,
                ...{
                    objects: action.payload.objects,
                    avatar_file: null,
                },
            }

        case actions.type.SET_DEFAULT_CURRENT_OBJECT:
            return {
                ...state,
                ...{
                    currentObject: defaultObject,
                    avatar_file: null,
                },
            }

        case actions.type.UPDATE_CURRENT_OBJECT:
            return {
                ...state,
                ...{
                    currentObject: {
                        ...state.currentObject,
                        ...action.payload.object,
                    },
                },
            }

        case actions.type.SAVE_CURRENT_OBJECT:
            return state

        case actions.type.DELETE_OBJECT:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.SHOW_MODAL_CURRENT_OBJECT_INFO:
            return {
                ...state,
                ...{
                    modalInfoObjectState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_OBJECT_INFO:
            return {
                ...state,
                ...{
                    modalInfoObjectState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_OBJECT:
            return {
                ...state,
                ...{
                    modalConfirmDeleteObjectState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_OBJECT:
            return {
                ...state,
                ...{
                    modalConfirmDeleteObjectState: false,
                },
            }

        case actions.type.UPDATE_AVATAR:
            return {
                ...state,
                ...{
                    avatar_file: action.payload.avatar,
                },
            }

        case actions.type.GET_LIST_OBJECT_QUERY_BY_ID_DONE:
            return {
                ...state,
                ...{
                    currentListObject: action.payload.data,
                },
            }

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_OBJECT:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch
                }
            }

        default:
            return state
    }
}

export default reducer
